import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Sidebar from "./Sidebar";
import routes from "../routes";
import iconSet from "../selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import OrderFormReg from "../pages/OrderFormReg";

const props = {
 margin:'0 auto',
}
function Footer() {
  const [orderId, setOrderId] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isHovering1, setIsHovering1] = useState(false);
  const [isHovering2, setIsHovering2] = useState(false);
  const [isHovering3, setIsHovering3] = useState(false);
  const [isHovering4, setIsHovering4] = useState(false);

  const toggleHandler = () => {
    if (isOpen) {
      setIsOpen(false)
    }else 
    {
      setIsOpen(true);
    }
    
  };

  // const handleMouseEnter = () => {
  //   setIsHovering(true);
  // };

  // const handleMouseLeave = () => {
  //   setIsHovering(false);
  // };
  
  return (
    <div>
       <footer>
        <div id="footers">
          <div
            id="Rgc-Footer-Mobile"
            className="rgc-mobile-footer"
          >
            <Row className="justify-content-between rgc-mobile-content g-0">
              <Col xs={2}>
                <NavLink to="dashboard">
                  <div className="d-flex flex-column rgc-footer-item">
                    {/* <i class="fas fa-home"></i> */}
                    <div>
                    <IcomoonReact
                     {...props} 
                     className="rgc-ico"
                      iconSet={iconSet}
                      color= {isHovering1 ? '#E78E09' : '#444'}
                      size={30}
                      icon="home-2"
                      onMouseEnter={() => setIsHovering1(true)}
                      onMouseLeave={() => setIsHovering1(false)}
                      />   
                      </div>
                    <span>داشبورد</span>
                  </div>
                </NavLink>
              </Col>

              <Col xs={2}>          
                <NavLink to="orders">
                <div className="d-flex flex-column rgc-footer-item">
                  {/* <i class="fa fa-clipboard-list"></i> */}
                  <div>
                  <IcomoonReact
                     className="rgc-ico"
                      iconSet={iconSet}
                      color= {isHovering2 ? '#E78E09' : '#444'}
                      size={30}
                      icon="task-square"
                      onMouseEnter={() => setIsHovering2(true)}
                      onMouseLeave={() => setIsHovering2(false)}
                      />
                    </div>
                  <span> سفارشات</span>
                </div>
                </NavLink>           
              </Col>
              

              <Col xs={2}>
                <div onClick={toggleHandler} >
                <div className="d-flex flex-column rgc-footer-item">
                    {/* <i class="fas fa-bell"></i> */}
                    <div>
                    <IcomoonReact
                     className="rgc-ico"
                      iconSet={iconSet}
                      color= {isHovering3 ? '#E78E09' : '#444'}
                      size={30}
                      icon="alarm"
                      onMouseEnter={() => setIsHovering3(true)}
                      onMouseLeave={() => setIsHovering3(false)}
                      />
                      </div>
                    <span>ثبت سفارش</span>
                </div>
                </div>
              </Col>

              <Col xs={2}>
                <NavLink to="report">
                <div className="d-flex flex-column rgc-footer-item">
                    {/* <i class="fa fa-trophy"></i> */} 
                    <i class="fa-solid fa-list-ul mb-1"></i>      
                    <span>گزارش </span>
                </div>
                </NavLink>
              </Col>

              <Col xs={2}>
                <NavLink to="wallet">
                <div className="d-flex flex-column rgc-footer-item">
                    <div>               
                    <IcomoonReact  
                       {...props}                 
                      iconSet={iconSet}
                      color= {isHovering4 ? '#E78E09' : '#444'}
                      size={30}
                      icon="cup"
                      onMouseEnter={() => setIsHovering4(true)}
                      onMouseLeave={() => setIsHovering4(false)}
                      />
                      </div>
                    <span>امتیاز </span>
                </div>
                </NavLink>
              </Col>
    
            </Row>
          </div>
        </div>
      </footer>
      <OrderFormReg toggle={isOpen} toggleHandler1={toggleHandler} />
    </div>
  );
}

export default Footer;
